 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"404":"404","auth":"auth","barCodes":"barCodes","cashOperation~category~online-order~product~repair~sale~sale-returned~sale-users~users~workingShift":"cashOperation~category~online-order~product~repair~sale~sale-returned~sale-users~users~workingShift","cashOperation":"cashOperation","category":"category","online-order":"online-order","product":"product","repair":"repair","sale":"sale","sale-returned":"sale-returned","sale-statistic~sale-users":"sale-statistic~sale-users","sale-users":"sale-users","users":"users","workingShift":"workingShift","dashboard":"dashboard","history~settings":"history~settings","history":"history","settings":"settings","inventory":"inventory","sale-statistic":"sale-statistic","user-settings":"user-settings","change-base":"change-base","close-repair":"close-repair","confirm":"confirm","create-base":"create-base","create-sale":"create-sale","info-base":"info-base","repair-calculator":"repair-calculator"}[chunkId]||chunkId) + "." + {"404":"8c0ee5fe","auth":"7bbe04c1","barCodes":"5301df84","cashOperation~category~online-order~product~repair~sale~sale-returned~sale-users~users~workingShift":"640273b2","cashOperation":"1412caee","category":"d4ab7f52","online-order":"307ca1b8","product":"a77bcb67","repair":"0400aae8","sale":"be6613aa","sale-returned":"10fd1364","sale-statistic~sale-users":"c0ff28ff","sale-users":"d969f572","users":"23813ea5","workingShift":"6d663071","chunk-7b57d2f9":"0a316ada","dashboard":"149e4df1","history~settings":"d083fa24","history":"4e1509b8","settings":"7f8fa7ea","inventory":"903c401c","sale-statistic":"3c548998","user-settings":"4c73a9f6","change-base":"8c90e52c","close-repair":"b66e5c84","confirm":"bb1fb4b0","create-base":"e42bc7bf","create-sale":"f7235df2","info-base":"63e6fb26","repair-calculator":"79b5be97"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"404":1,"auth":1,"barCodes":1,"cashOperation~category~online-order~product~repair~sale~sale-returned~sale-users~users~workingShift":1,"cashOperation":1,"category":1,"online-order":1,"product":1,"repair":1,"sale":1,"sale-returned":1,"sale-users":1,"users":1,"workingShift":1,"chunk-7b57d2f9":1,"dashboard":1,"history~settings":1,"history":1,"settings":1,"inventory":1,"sale-statistic":1,"user-settings":1,"change-base":1,"close-repair":1,"confirm":1,"create-base":1,"create-sale":1,"info-base":1,"repair-calculator":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"404":"404","auth":"auth","barCodes":"barCodes","cashOperation~category~online-order~product~repair~sale~sale-returned~sale-users~users~workingShift":"cashOperation~category~online-order~product~repair~sale~sale-returned~sale-users~users~workingShift","cashOperation":"cashOperation","category":"category","online-order":"online-order","product":"product","repair":"repair","sale":"sale","sale-returned":"sale-returned","sale-statistic~sale-users":"sale-statistic~sale-users","sale-users":"sale-users","users":"users","workingShift":"workingShift","dashboard":"dashboard","history~settings":"history~settings","history":"history","settings":"settings","inventory":"inventory","sale-statistic":"sale-statistic","user-settings":"user-settings","change-base":"change-base","close-repair":"close-repair","confirm":"confirm","create-base":"create-base","create-sale":"create-sale","info-base":"info-base","repair-calculator":"repair-calculator"}[chunkId]||chunkId) + "." + {"404":"3790505d","auth":"a710ca51","barCodes":"387bc147","cashOperation~category~online-order~product~repair~sale~sale-returned~sale-users~users~workingShift":"c0cb13e6","cashOperation":"108afc8e","category":"e73b9375","online-order":"4bec6762","product":"25edbbf4","repair":"122ccef1","sale":"5550b12a","sale-returned":"da5e38b8","sale-statistic~sale-users":"31d6cfe0","sale-users":"61449b63","users":"4aad2e7f","workingShift":"79885295","chunk-7b57d2f9":"a161d41d","dashboard":"92f9fd5e","history~settings":"c0cb13e6","history":"bbb96a9e","settings":"09adfec5","inventory":"f30f418d","sale-statistic":"9a8fda68","user-settings":"dd1d580d","change-base":"a2011c56","close-repair":"4b4c6834","confirm":"b35cb764","create-base":"71ba3008","create-sale":"502c97a1","info-base":"7354e691","repair-calculator":"2f4d7c3e"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
